import React from "react";
import { dialog, Progress } from "../../../../nq-component";
import {
  deleteObjectUseCase,
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import FormFactory from "../../../../components/FormFactory";
import { Link, Navigate } from "react-router-dom";
import schemaContactPerson from "./schemas/schemaContactPerson.json";
import schemaPersonalForm1 from "./schemas/schemaPersonalForm1.json";
import schemaPersonalForm2 from "./schemas/schemaPersonalForm2.json";
import schemaIdForm from "./schemas/schemaIdForm.json";
import schemaEmployment from "./schemas/schemaEmployment.json";
import schemaCharacterRef from "./schemas/schemaCharacterRef.json";
import schemaElementaryForm from "./schemas/schemaElementaryForm.json";
import schemaHSForm from "./schemas/schemaHSForm.json";
import schemaColForm from "./schemas/schemaColForm.json";
import schemaDocForm from "./schemas/schemaDocForm.json";
import schemaPresentAddress from "./schemas/schemaPresentAddress.json";
import schemaPermanentAddress from "./schemas/schemaPermanentAddress.json";
import InputFactory from "../../../../components/InputFactory";
import NavBar from "../../../../components/navbar";
import MyWalkInApplicantFormPresenter from "./MyWalkInApplicantFormPresenter";
import DialogInterviewForm from "../../components/DialogInterviewForm";
import DialogConfirmation from "../../components/DialogConfirmation";
import schemaOtherDocs from "./schemas/schemaOtherDocs.json";
import DialogAssignCoordinator from "../../components/DialogAssignCoordinator";
import DialogWarning from "../../components/DialogWarning";
import DialogSuccess from "../../components/DialogSuccess";
import DialogOnboard from "../../components/DialogOnboard";
import { footer } from "framer-motion/client";
import { saveFileUseCase, saveImageUseCase } from "../../../../usecases/file";
import RelationForm from "../../../../components/RelationForm";
import DialogRemarks from "../../components/DialogRemarks";
import StatusProgress from "../../../../components/StatusProgress";
import { auditUseCase } from "../../../../usecases/audit";

class MyWalkInApplicantFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      positions: [],
      selectedPosition: "",
      locations: [],
      location: "",
      remarks: "",
      onBoards: [],
      clients: [],
      client: "",
      coordinators: [],
      coordinatorId: "",
      isAddressSame: false,
      recruiters: [],
      age: 0,
      image: "",
      employers: [{ id: crypto.randomUUID() }],
      characterref: [{ id: crypto.randomUUID() }],
      rejectionReason: "",
    };
    this.presenter = new MyWalkInApplicantFormPresenter(
      this,
      upsertUseCase(),
      getObjectUseCase(),
      findObjectUseCase(),
      deleteObjectUseCase(),
      auditUseCase()
    );
  }

  componentDidMount() {
    this.getJobPositions();
    const { object } = this.state;

    this.setState({ image: object?.image2 || "" });

    const session = JSON.parse(sessionStorage.getItem("interviewDatasWalkIn"));
    if (session) {
      this.setState({ image: session.file });
    }

    this.presenter.componentDidMount();
  }

  componentWillUnmount() {
    sessionStorage.removeItem("interviewDatasWalkIn");
  }

  getCollectionName() {
    return "walkIn_applicants";
  }

  handleClickSchedule(startDateTime, endDateTime) {
    dialog.close();
    this.presenter.handleClickSchedule(startDateTime, endDateTime);
  }

  handleBackToPoll() {
    dialog.close();
    this.presenter.handleBackToPoll();
  }

  handleOnchange() {}

  getJobPositions() {
    this.presenter.getJobPositions();
  }
  navigateToForm() {
    this.presenter.navigateToForm();
  }

  getLocations() {
    this.presenter.getLocations();
  }

  getCoordinators(location) {
    this.presenter.getCoordinators(location);
  }

  handleChange(event) {
    const selectedPosition = event.target.value;
    this.setState({ selectedPosition });
  }

  handleLocationChange(event) {
    const location = event.target.options[event.target.selectedIndex].text;
    console.log("Selected text:", location);
    console.log(event);
    this.setState({ location: location });
  }

  handleClientChange(event) {
    const client = event.target.options[event.target.selectedIndex].text;
    console.log("Selected text:", client);
    console.log(event);
    this.setState({ client: client });
  }

  handleCoordinatorChange(event) {
    const coordinatorId = event.target.value;
    this.setState({ coordinatorId });
  }

  showDialogWarning(message) {
    dialog.fire({
      html: <DialogWarning message={message} />,
      footer: false,
    });
    return null;
  }

  onContinue() {
    dialog.fire({
      html: <DialogSuccess message="Successfully Updated Data" />,
      footer: false,
    });
  }

  continueToPoll() {
    dialog.close();
    dialog.fire({
      html: (
        <DialogConfirmation handleAssign={this.handleBackToPoll.bind(this)} />
      ),
      footer: false,
    });
  }

  onChangeRemarks(event) {
    const value = event.target.value;
    this.setState({ remarks: value }, () => {
      console.log(this.state.remarks);
    });
  }

  backToPoll() {
    const { remarks } = this.state;
    dialog.fire({
      html: (
        <DialogRemarks
          onchange={this.onChangeRemarks.bind(this)}
          remarks={remarks}
          oncontinue={this.continueToPoll.bind(this)}
        />
      ),
      footer: false,
    });
  }

  interviewSubmit() {
    const { object } = this.state;
    if (object?.interviewForm) {
      this.navigateToForm();
      return;
    }
    try {
      this.setState((prevState) => {
        dialog.fire({
          html: (
            <DialogInterviewForm
              handleAssign={this.handleClickSchedule.bind(this)}
              positions={prevState.positions}
              application={prevState.object}
              navigate={this.navigateToForm.bind(this)}
              handleChange={this.handleChange.bind(this)}
            />
          ),
          footer: false,
        });

        return null;
      });
    } catch (error) {
      console.error("Error fetching job positions:", error);
    }
  }

  onContinueSubmit(coordinatorId) {
    this.presenter.continueSubmit(coordinatorId);
  }
  onContinue() {
    try {
      this.setState((prevState) => {
        dialog.fire({
          html: (
            <DialogAssignCoordinator
              handleClientValue={this.handleClientChange.bind(this)}
              handleLocationValue={this.handleLocationChange.bind(this)}
              handleCoordinatorChange={this.handleCoordinatorChange.bind(this)}
              clients={prevState.clients}
              locations={prevState.locations}
              location={prevState.location}
              coordinators={prevState.coordinators}
              submit={this.onContinueSubmit.bind(this)}
            />
          ),
          footer: false,
        });

        return null;
      });
    } catch (error) {
      console.error("Error fetching job positions:", error);
    }
  }

  successModal(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  handleClickSchedule(startDateTime, endDateTime) {
    dialog.close();
    this.presenter.handleClickSchedule(startDateTime, endDateTime);
  }

  goBack() {
    this.presenter.goBack();
  }

  handleClickOnboard(startDateTime, endDateTime, date) {
    dialog.close();
    this.presenter.handleClickOnboard(startDateTime, endDateTime, date);
  }
  onBoardSubmit() {
    const user = this.getCurrentUser();
    const { onBoards } = this.state;
    dialog.fire({
      html: (
        <DialogOnboard
          onBoards={onBoards}
          user={user}
          handleAssign={this.handleClickOnboard.bind(this)}
        />
      ),
      footer: false,
    });
  }

  handleToReprocess() {
    dialog.close();
    this.presenter.handleToReprocess();
  }

  toReprocess() {
    dialog.fire({
      html: (
        <DialogConfirmation
          handleAssign={this.handleToReprocess.bind(this)}
          message={`Are you sure you want to put this application to your "My Re-Process"? This action can't be undone.`}
        />
      ),
      footer: false,
    });
  }

  listButton() {
    const { object } = this.state;
    const interviewDatas = sessionStorage.getItem("interviewDatasWalkIn");

    const user = this.getCurrentUser();
    const role = user.roles[0]?.id;
    console.log(interviewDatas);
    switch (object.status) {
      // case "New":
      //   return (
      //     <button
      //       className="btn text-white"
      //       style={{ backgroundColor: "#D18237" }}
      //       onClick={this.scheduleSubmit.bind(this)}
      //     >
      //       <i class="bi bi-calendar-event me-2"></i>
      //       Schedule
      //     </button>
      //   );
      //   break;
      case "For Interview":
        return (
          <>
            <button
              className="btn text-white fw-bold"
              style={{ backgroundColor: "#3174ad" }}
              onClick={this.interviewSubmit.bind(this)}
            >
              <i class="bi bi-file-earmark-text me-2 fw-bold"></i>
              Interview Form
            </button>{" "}
            <button
              disabled={!object?.interviewForm}
              className={`btn text-white fw-bold`}
              style={{
                backgroundColor: !object?.interviewForm
                  ? "#f57c0054"
                  : "#f57c00",
              }}
              onClick={this.onContinue.bind(this)}
            >
              <i class="bi bi-clipboard-check me-2"></i>
              Continue
            </button>{" "}
            <button
              className="btn text-white fw-bold"
              disabled={!object?.interviewForm}
              style={{
                backgroundColor: !object?.interviewForm
                  ? "#ffc10761"
                  : "#ffc107",
              }}
              onClick={this.toReprocess.bind(this)}
            >
              <i class="bi bi-repeat me-2"></i>
              Re-process
            </button>{" "}
            <button
              disabled={!object?.interviewForm}
              className="btn text-dark fw-bold"
              style={{ backgroundColor: "#d3d3d3" }}
              onClick={this.backToPoll.bind(this)}
            >
              <i class="bi bi-reply-fill me-2"></i>
              Back to Poll
            </button>
          </>
        );
        break;
      case "For Endorsement":
        return (
          <>
            <button
              className="btn text-white fw-bold"
              style={{ backgroundColor: "#3174ad" }}
              onClick={this.interviewSubmit.bind(this)}
            >
              <i class="bi bi-file-earmark-text me-2 fw-bold"></i>
              Interview Form
            </button>{" "}
            <button
              className="btn text-white"
              style={{ backgroundColor: "#D18237" }}
              onClick={this.onBoardSubmit.bind(this)}
            >
              <i class="bi bi-calendar-event me-2"></i>
              Onboard
            </button>
          </>
        );
        break;
      default:
        return (
          <>
            <button
              className="btn text-white fw-bold"
              style={{ backgroundColor: "#3174ad" }}
              onClick={this.interviewSubmit.bind(this)}
            >
              <i class="bi bi-file-earmark-text me-2 fw-bold"></i>
              Interview Form
            </button>
          </>
        );
        break;
    }
  }

  rejectButton() {
    const { object } = this.state;
    switch (object.status) {
      case "New":
      case "For Interview":
      case "For Coordinator":
      case "For Endorsement":
      case "On-boarding":
        return (
          <>
            <button
              className="btn text-white fw-bold ms-1"
              style={{ backgroundColor: "#FF5722" }}
              onClick={this.onReject.bind(this)}
            >
              <i class="bi bi-x-circle me-2 fw-bold"></i>
              Reject
            </button>
          </>
        );
        break;
      default:
        return "";
        break;
    }
  }

  showConfirmationDialog(onConfirm, message) {
    dialog.fire({
      html: <DialogConfirmation handleAssign={onConfirm} message={message} />,
      footer: false,
    });
  }

  rejectApplication() {
    this.presenter.rejectApplication();
  }

  formSubmit(e) {
    e.preventDefault();

    this.presenter.submitForm();
  }

  showModal(title, message) {
    dialog.fire({
      html: <DialogWarning title={title} message={message} />,
      footer: false,
    });
  }

  onChangePersonal(value, field) {
    this.presenter.onChangePersonal(value, field);

    switch (field) {
      case "birthDate":
        const today = new Date();
        const birthDate = new Date(value);
        const age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        const calculatedAge =
          monthDifference < 0 ||
          (monthDifference === 0 && today.getDate() < birthDate.getDate())
            ? age - 1
            : age;

        if (calculatedAge < 0) {
          this.showModal(
            "Invalid Birth Date",
            "The birth date you entered is in the future. Please enter a valid birth date."
          );
          return;
        }

        this.setState({ age: calculatedAge });
        this.presenter.onChangePersonal(calculatedAge, "age");
        break;
      default:
        break;
    }
  }

  addEmployer = () => {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
        employmentBackground: [
          ...(prevState.object.employmentBackground || []),
          { id: crypto.randomUUID() },
        ],
      },
    }));
  };

  addCharacterRef = () => {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
        characterReferences: [
          ...(prevState.object.characterReferences || []),
          { id: crypto.randomUUID() },
        ],
      },
    }));
  };

  removeEmployer = (id) => {
    if (this.state.object.employmentBackground.length > 1) {
      this.setState((prevState) => ({
        object: {
          ...prevState.object,
          employmentBackground: prevState.object.employmentBackground.filter(
            (employer) => employer.id !== id
          ),
        },
      }));
      this.presenter.removeEmployment(id);
      console.log(this.state.object.employmentBackground);
      console.log(id);
    }
  };

  removeCharacterRef = (id) => {
    this.setState((prevState) => ({
      object: {
        ...prevState.object,
        characterReferences: prevState.object.characterReferences.filter(
          (character) => character.id !== id
        ),
      },
    }));
    this.presenter.removeCharacterRef(id);
    console.log(this.state.object.characterReferences);
    console.log(id);
  };
  onChangeLGS(value, field) {
    this.setState({ whereLGSSee: value });
    this.presenter.onChangePersonal(value, field);
  }
  onChangeRecruiter(event) {
    this.presenter.onChangeRecruiter(event);
  }

  toggleCheckbox(event) {
    const isChecked = event.target.checked;
    this.setState({ isAddressSame: isChecked });
  }

  onUpdateSubmit() {
    this.presenter.onUpdate();
  }

  viewFile(fileUrl) {
    window.open(fileUrl, "_blank");
  }

  onChangeReason(event) {
    const value = event.target.value;
    this.setState({ rejectionReason: value });
  }

  onReject() {
    const { remarks } = this.state;
    dialog.fire({
      html: (
        <DialogRemarks
          onchange={this.onChangeReason.bind(this)}
          remarks={remarks}
          oncontinue={this.rejectApplication.bind(this)}
        />
      ),
      footer: false,
    });
  }

  render() {
    const {
      object,
      whereLGSSee,
      // location,
      // coordinators,
      // coordinatorId,
      // employers,
      positions,
      image,
      onBoards,
      isAddressSame,
      progress,
      recruiters,
      age,
    } = this.state;
    const user = this.getCurrentUser();

    const interviewDatas = JSON.parse(
      sessionStorage.getItem("interviewDatasWalkIn")
    );

    const role = user?.roles[0].id;
    const positionOptions = positions?.map(
      (position) => position?.positionTitle
    );

    // const isAddressSame =
    //   object.permanent_barangay === object.present_barangay &&
    //   object.permanent_city === object.present_city &&
    //   object.permanent_houseNumber === object.present_houseNumber &&
    //   object.permanent_province === object.present_province &&
    //   object.permanent_street === object.present_street &&
    //   object.permanent_subdivision === object.present_subdivision &&
    //   object.permanent_zipCode === object.present_zipCode &&
    //   object.telephone === object.present_telephone;
    return (
      <>
        <NavBar user={user} />

        <div>
          <div className="p-4 overflow-auto">
            <div className="d-flex gap-4 justify-content-between">
              <div className="d-flex">
                <h1 className="fw-bold fs-4">
                  <div className="d-flex gap-3 mb-3 align-items-center">
                    <div
                      className="rounded-5 p-1 cursor-pointer"
                      style={{ backgroundColor: `#E6E6E6` }}
                      onClick={this.goBack.bind(this)}
                    >
                      <i
                        class="bi bi-arrow-left-short"
                        style={{ width: `1rem`, height: `1rem` }}
                      ></i>
                    </div>
                    <span style={{ color: `#D18237` }}>Application Form</span>
                  </div>
                </h1>
              </div>

              <div>
                {this.listButton()}
                {this.rejectButton()}
              </div>
            </div>

            <StatusProgress status={object?.status} object={object} />

            {object?.rejectionReason && (
              <div className="bg-white p-4 rounded-3 mt-3 border border-1 border-danger">
                <h6
                  className="text-uppercase fw-bold mb-3 text-danger"
                  style={{ color: "#D18237" }}
                >
                  Rejected by Recruiter
                </h6>
                <div
                  className="d-flex flex-column gap-2"
                  style={{ fontSize: "0.9rem" }}
                >
                  <div className="d-flex gap-2">
                    <span className="fw-bold text-muted">Remarks:</span>
                    <span className="text-dark">
                      {object?.rejectionReason || "No reason available"}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {object?.remarks ? (
              <div className="bg-white p-4 rounded-3 mt-3 border border-1 border-danger">
                <h6
                  className="text-uppercase fw-bold mb-3 text-danger"
                  style={{ color: "#D18237" }}
                >
                  Rejected by Coordinator
                </h6>
                <div
                  className="d-flex flex-column gap-2"
                  style={{ fontSize: "0.9rem" }}
                >
                  <div className="d-flex gap-2">
                    <span className="fw-bold text-muted">Remarks:</span>
                    <span className="text-dark">
                      {object?.remarks || "No remarks available"}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {progress ? (
              <div className="d-flex justify-content-center align-items-center h-100 bg-white mt-3 py-5">
                <Progress />
              </div>
            ) : (
              <div className="d-flex flex-column">
                <div className="bg-white mt-4 p-4 rounded-3 d-flex flex-column gap-0">
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="fs-5 fw-bold p-0 m-0">Instructions:</p>
                      <p className="p-0 m-0">
                        1. Answer ALL questions completely and accurately.
                      </p>
                      <p className="p-0 m-0">
                        2. Provide all information to the best of your
                        knowledge.
                      </p>
                    </div>
                    <div>
                      <div className="d-flex gap-2 mt-4">
                        {role === "Recruiter" || role === "Coordinator" ? (
                          <button
                            type="submit"
                            className="p-2 text-white rounded-1 border-0 fw-bold px-4"
                            style={{ backgroundColor: `#D18237` }}
                            onClick={this.onUpdateSubmit.bind(this)}
                          >
                            Update Application
                          </button>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column col-lg-4 justify-content-md-start mt-3 gap-2">
                      <div className="d-flex flex-column gap-2">
                        <b>Where did you see LGS?</b>
                        <InputFactory
                          type="Enum"
                          required
                          options={[
                            "Walk-in",
                            "Social Media",
                            // "Recruiter",
                            "Word of Mouth",
                          ]}
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="seeLGS"
                          defaultValue={object.seeLGS}
                          onChange={this.onChangeLGS.bind(this)}
                        />
                        {whereLGSSee === "Recruiter" ? (
                          <div>
                            <select
                              className="form-control bg-light-subtle p-2"
                              onChange={this.onChangeRecruiter.bind(this)}
                            >
                              <option selected>Select Recruiter</option>
                              {recruiters.map((recruiter, index) => (
                                <option key={index} value={recruiter?.id}>
                                  {recruiter.employee?.firstName +
                                    ` ${recruiter.employee?.lastName}`}
                                </option>
                              ))}
                            </select>
                          </div>
                        ) : (
                          <div className="d-flex flex-column">
                            <p className="text-muted m-0 p-0">
                              Position/s Applied for:
                            </p>

                            <InputFactory
                              type="Enum"
                              options={positionOptions}
                              required
                              className="form-control bg-light-subtle p-2"
                              placeholder="Select"
                              field="positionApplied"
                              defaultValue={object.positionApplied}
                              onChange={this.onChangePersonal.bind(this)}
                            />
                            {/* <div>
                            <select
                              name="positionApplied"
                              required
                              className="form-control bg-light-subtle p-2"
                              onChange={(e) =>
                                this.onChangePersonal(
                                  e.target.value,
                                  "positionApplied"
                                )
                              }
                            >
                              <option selected disabled>
                                {object?.positionApplied}
                              </option>
                              {positions.map((job, index) => (
                                <option key={index} value={job?.positionTitle}>
                                  {job?.positionTitle}
                                </option>
                              ))}
                            </select>
                          </div> */}
                          </div>
                        )}
                      </div>
                      <div className="mt-2">
                        <b>Do you have any relative in:</b>
                        <div className="mt-2">
                          <label className="form-label fs-sm">LGS</label>
                          <InputFactory
                            type="Enum"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeLGS"
                            defaultValue={object.relativeLGS}
                            onChange={this.onChangePersonal.bind(this)}
                          />
                        </div>
                        <div>
                          <label className="form-label fs-sm">Client</label>
                          <InputFactory
                            type="Enum"
                            options={["Yes", "No"]}
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="relativeClient"
                            defaultValue={object.relativeClient}
                            onChange={this.onChangePersonal.bind(this)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="container-fluid mt-3">
                      <div className="row justify-content-center g-4">
                        <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column align-items-center">
                          <label className="fw-bold mb-2">
                            Image 1
                            <span className="text-danger fw-lighter ms-1">
                              *
                            </span>
                          </label>
                          <div
                            className="position-relative w-100 rounded-3 border"
                            style={{ maxWidth: "300px", aspectRatio: "1 / 1" }}
                          >
                            {object?.image1 ? (
                              <>
                                <img
                                  className="w-100 h-100 img-fluid rounded-1"
                                  src={object?.image1}
                                  alt="Uploaded file"
                                  style={{ objectFit: "cover" }}
                                />
                                <button
                                  className="btn btn-sm bg-white position-absolute"
                                  onClick={() => this.viewFile(object?.image1)}
                                  style={{ top: "5px", right: "5px" }}
                                >
                                  <i className="bi bi-eye text-success"></i>
                                </button>
                              </>
                            ) : (
                              <a href="#uploadImage">
                                <img
                                  className="w-100 h-100 img-fluid rounded-1 bg-light"
                                  src="/defaultImage.png"
                                  alt="Default"
                                  style={{ objectFit: "cover" }}
                                />
                              </a>
                            )}
                          </div>
                        </div>

                        <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column align-items-center">
                          <label className="fw-bold mb-2">
                            Image 2
                            <span className="text-danger fw-lighter ms-1">
                              *
                            </span>
                          </label>
                          <div
                            className="position-relative w-100 rounded-3 border"
                            style={{ maxWidth: "300px", aspectRatio: "1 / 1" }}
                          >
                            {image || object?.image2 ? (
                              <>
                                <img
                                  className="w-100 h-100 img-fluid rounded-1"
                                  src={image || object?.image2}
                                  alt="Uploaded file"
                                  style={{ objectFit: "cover" }}
                                />
                                <button
                                  className="btn btn-sm bg-white position-absolute"
                                  onClick={() =>
                                    this.viewFile(image || object?.image2)
                                  }
                                  style={{ top: "5px", right: "5px" }}
                                >
                                  <i className="bi bi-eye text-success"></i>
                                </button>
                              </>
                            ) : (
                              <a href="#uploadImage">
                                <img
                                  className="w-100 h-100 img-fluid rounded-1 bg-light"
                                  src="/defaultImage.png"
                                  alt="Default"
                                  style={{ objectFit: "cover" }}
                                />
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <b>Personal Information</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaPersonalForm1}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                    <span
                      className="d-inline-block col-md-2 col-lg-1"
                      style={{ marginTop: `1rem` }}
                    >
                      <small>
                        Age<span className="text-danger ms-1">*</span>
                      </small>
                      <p
                        className="bg-light-subtle p-2 cursor-pointer text-center fw-bold border border-1 rounded-1"
                        style={{ marginTop: `0.5rem` }}
                      >
                        {age || object.age}
                      </p>
                    </span>
                    <FormFactory
                      schema={schemaPersonalForm2}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="mt-4">
                      <b>Present Address</b>
                    </div>
                    <FormFactory
                      schema={schemaPresentAddress}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex gap-2">
                      <input
                        type="checkbox"
                        onChange={this.toggleCheckbox.bind(this)}
                        className="cursor-pointer"
                      />
                      <p className="m-0 p-0">
                        Permanent Address same as a Present Address
                      </p>
                    </div>
                  </div>

                  {!isAddressSame ? (
                    <div className="row justify-content-md-start mt-3">
                      <div className="mt-4">
                        <b>Permanent Address</b>
                      </div>
                      <FormFactory
                        schema={schemaPermanentAddress}
                        object={object}
                        onChange={this.onChangePersonal.bind(this)}
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaIdForm}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                  <div className="mt-4">
                    <b>Emergency Contact Person</b>
                    <hr></hr>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaContactPerson}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                  <div className="mt-4">
                    <b>Educational Information</b>
                    <hr />
                  </div>
                  <div className="mt-4">
                    <b>Elementary</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaElementaryForm}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>

                  <div className="mt-4">
                    <b>High School</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaHSForm}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                  <div className="mt-4">
                    <b>College</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaColForm}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex">
                      <InputFactory
                        type="Boolean"
                        field="isFreshGrad"
                        label="Fresh Graduate"
                        object={object}
                        onChange={this.onChangePersonal.bind(this)}
                      />
                    </div>
                  </div>
                  <div>
                    <RelationForm
                      title="Employment Background"
                      schema={schemaEmployment}
                      objects={object?.employmentBackground}
                      object={object}
                      onChangeForm={this.presenter.onChangeEmployment}
                      addForm={this.addEmployer}
                      remove={this.removeEmployer}
                      field="employmentBackground"
                    />
                  </div>
                  <div>
                    <RelationForm
                      title="Character References"
                      schema={schemaCharacterRef}
                      objects={object?.characterReferences}
                      object={object}
                      onChangeForm={this.presenter.onChangecharacteref}
                      addForm={this.addCharacterRef}
                      remove={this.removeCharacterRef}
                      field="characterReferences"
                    />
                    {/* <InputFactory
                    type="Relation"
                    schema={schemaCharacterRef}
                    object={object}
                    objects={object?.characterReferences}
                    field="characterReferences"
                    schemas={schemas}
                  /> */}
                  </div>

                  <div className="mt-4">
                    <b>School Record</b>
                    <hr />
                  </div>

                  <div className="d-flex flex-row justify-content-md-start mt-3 gap-3">
                    {
                      <div className="col-lg-3">
                        <label>Diploma</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Diploma"
                          field="diploma"
                          object={object}
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                    }
                    {
                      <div className="col-lg-3">
                        <label>TOR</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="TOR"
                          field="tor"
                          object={object}
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                    }
                    {
                      <div className="col-lg-3">
                        <label>Report Card</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Report Card"
                          field="reportCard"
                          object={object}
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                    }
                    {
                      <div className="col-lg-3">
                        <label>Graduation Certificate</label>
                        <InputFactory
                          type="String"
                          _type="File"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="GraduationCertificate"
                          field="graduationCertificate"
                          object={object}
                          onChange={this.onChangePersonal.bind(this)}
                        />
                      </div>
                    }
                  </div>
                  <div className="mt-4">
                    <b>Upload Documents</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaDocForm}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaOtherDocs}
                      object={object}
                      onChange={this.onChangePersonal.bind(this)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(MyWalkInApplicantFormPage);
